export class BasicStrengthCSVDTO {
  public class_id = 0;
  public S01Initiatives = 0;
  public S02ForceToWork = 0;
  public S03Execution = 0;
  public S04DiscoverIssues = 0;
  public S05Planning = 0;
  public S06Creativity = 0;
  public S07Outgoing = 0;
  public S08Listening = 0;
  public S09Flexibility = 0;
  public S10GraspTheSituation = 0;
  public S11Discipline = 0;
  public S12StressControl = 0;

  static fromDB(record: { [column: string]: any; [column: number]: any }): BasicStrengthCSVDTO {
    const entity = new BasicStrengthCSVDTO();
    entity.class_id = record['class_id'];
    entity.S01Initiatives = record['S01Initiatives'];
    entity.S02ForceToWork = record['S02ForceToWork'];
    entity.S03Execution = record['S03Execution'];
    entity.S04DiscoverIssues = record['S04DiscoverIssues'];
    entity.S05Planning = record['S05Planning'];
    entity.S06Creativity = record['S06Creativity'];
    entity.S07Outgoing = record['S07Outgoing'];
    entity.S08Listening = record['S08Listening'];
    entity.S09Flexibility = record['S09Flexibility'];
    entity.S10GraspTheSituation = record['S10GraspTheSituation'];
    entity.S11Discipline = record['S11Discipline'];
    entity.S12StressControl = record['S12StressControl'];
    return entity;
  }
}
